import { render, staticRenderFns } from "./CallKcbAuthPop.vue?vue&type=template&id=3cc2022b&scoped=true&"
import script from "./CallKcbAuthPop.vue?vue&type=script&lang=js&"
export * from "./CallKcbAuthPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc2022b",
  null
  
)

export default component.exports